import * as React from 'react';
import { useState } from 'react';
import { Categories } from '../types/Categories';

interface NewsSidebarProps {
    categories: Categories;
}

export const NewsSidebar: React.FC<NewsSidebarProps> = ({ categories }) => {
    const [filter, setFilter] = useState('');
    const [expanded, setExpanded] = useState(false);

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);

        if (!expanded && e.target.value) {
            setExpanded(true);
        }

        if (expanded && !e.target.value) {
            setExpanded(false);
        }
    };

    const toggleExpanded = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        setExpanded(!expanded);
    };

    const applyFilter = ([key, label]: [string, string]): boolean => {
        if (!filter) {
            return true;
        }

        const string = filter.toLowerCase();

        return key.toLowerCase().includes(string)
            || label.toLowerCase().includes(string);
    };

    return (
        <>
            <input
                type="search"
                value={filter}
                onChange={handleFilterChange}
                placeholder="Filter"
            />

            <div className={`chips ${expanded ? '' : '--collapsed'}`}>
                {Object.entries(categories)
                    .filter(applyFilter)
                    .map(([key, label]) => (
                        <a href={`/news?category=${key}`} className="chip" key={key}>
                            {label}
                        </a>
                    ))}
            </div>

            <a href="#" className="expander" onClick={toggleExpanded}>{expanded ? 'Collapse' : 'Expand'}</a>
        </>
    );
};
